'use strict';

var angular = require('angular');
var SaveNotificationModalDirective = function SaveNotificationModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/save-notification-modal.html'),
    controller: 'SaveNotificationModalController',
    scope: {
      postDeparture: '='
    },
    link: function link($scope, $element) {
      $scope.hideSaveModal = function () {
        $element.modal('hide');
        angular.element('body').removeClass('modal-open');
        angular.element('.modal-backdrop').remove();
        $scope.cancelStateChange();
      };
      $scope.$on('save-modal:openModal', function (event, nextState, fromState, callbacks) {
        $scope.nextState = nextState;
        $scope.fromState = fromState.name;
        $scope.callbacks = callbacks;
        if ($scope.isDirty()) {
          $scope.updateMessage();
          $element.modal('show');
        } else {
          $scope.onGridPristine();
        }
      });
    }
  };
};
SaveNotificationModalDirective.$inject = [];
module.exports = SaveNotificationModalDirective;